import { InsuranceForTransfer } from "../hooks/api/useGetCalculationById";

export const openPolicySigningText = ({
  firstName,
  lastName,
  ssn,
  insuranceTransferList,
}: {
  firstName: string;
  lastName: string;
  ssn: string;
  insuranceTransferList: InsuranceForTransfer[] | [] | undefined;
}) => {
  const htmlSignString = `
    <p>Jag, ${firstName} ${lastName} ${ssn}, godkänner att pensionssparande i följande försäkringar flyttas till nytecknade pensionsförsäkringar hos Idun Liv Försäkring AB:</p>
    <ul>${insuranceTransferList?.map((item) => `<li>${item.insuranceIdentifier} - ${item.insuranceCompany}</li>`)}</ul>
    <p>Genom att signera med BankID bekräftar jag att jag även har tagit del av (1) de allmänna villkoren för Samblas rådgivningstjänst och rådgivningsdokumentation, (2) förköpsinformation och försäkringsvillkoren för Idun Livs pensionsförsäkring samt (3) fondfaktablad och fondernas hållbarhetsupplysning.
    </p>
  `;
  return htmlSignString;
};
